import React from "react";
import useConstrainable from "./use-constrainable";

export default function useOnConstrain(callback, dependencies = []) {

    const constrainable = useConstrainable();

    React.useEffect(() => {
        constrainable.addOnConstrainEventListener(callback);

        return () => {
            constrainable.removeOnConstrainEventListener(callback);
        };
    }, dependencies);

}
